import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot, Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { firstValueFrom } from 'rxjs';
 
import { ProfileModel } from '../models/profile.model';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { DataService } from '../services/data/data.service';
 
@Injectable({
  providedIn: 'root',
})

export class AuthorityDetailsResolverService implements Resolve<ProfileModel> {

  constructor(private dataService: DataService, private auth:AuthenticationService) {
  }
 
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ProfileModel> {
    let id = route.paramMap.get('profileId');  
    const item = await firstValueFrom(this.dataService.getAuthorityDetails(id));
    const itemFull:ProfileModel = {
      key:id,
      role:'authority',
      details:item
    }
    return itemFull;
  }
}